__turbopack_context__.v({
  "activeTab": "Profile-module__DeDpKa__activeTab",
  "address": "Profile-module__DeDpKa__address",
  "addressContainer": "Profile-module__DeDpKa__addressContainer",
  "bentoGrid": "Profile-module__DeDpKa__bentoGrid",
  "bentoItem": "Profile-module__DeDpKa__bentoItem",
  "bentoItemStandalone": "Profile-module__DeDpKa__bentoItemStandalone",
  "blockchainIcon": "Profile-module__DeDpKa__blockchainIcon",
  "buttonGlow": "Profile-module__DeDpKa__buttonGlow",
  "buyButton": "Profile-module__DeDpKa__buyButton",
  "cancelled": "Profile-module__DeDpKa__cancelled",
  "chartContainer": "Profile-module__DeDpKa__chartContainer",
  "chevronButton": "Profile-module__DeDpKa__chevronButton",
  "completed": "Profile-module__DeDpKa__completed",
  "container": "Profile-module__DeDpKa__container",
  "copyButton": "Profile-module__DeDpKa__copyButton",
  "emptyState": "Profile-module__DeDpKa__emptyState",
  "error": "Profile-module__DeDpKa__error",
  "failed": "Profile-module__DeDpKa__failed",
  "glassmorphism": "Profile-module__DeDpKa__glassmorphism",
  "glow": "Profile-module__DeDpKa__glow",
  "hideOnDesktop": "Profile-module__DeDpKa__hideOnDesktop",
  "hideOnMobile": "Profile-module__DeDpKa__hideOnMobile",
  "ineligible": "Profile-module__DeDpKa__ineligible",
  "infoItem": "Profile-module__DeDpKa__infoItem",
  "infoItemHalf": "Profile-module__DeDpKa__infoItemHalf",
  "infoItemLabelWithBar": "Profile-module__DeDpKa__infoItemLabelWithBar",
  "infoItemRow": "Profile-module__DeDpKa__infoItemRow",
  "loadingContainer": "Profile-module__DeDpKa__loadingContainer",
  "loadingSpinner": "Profile-module__DeDpKa__loadingSpinner",
  "noDataMessage": "Profile-module__DeDpKa__noDataMessage",
  "noReferrals": "Profile-module__DeDpKa__noReferrals",
  "notVerified": "Profile-module__DeDpKa__notVerified",
  "orderAmount": "Profile-module__DeDpKa__orderAmount",
  "orderCard": "Profile-module__DeDpKa__orderCard",
  "orderDetails": "Profile-module__DeDpKa__orderDetails",
  "orderDetailsExpanded": "Profile-module__DeDpKa__orderDetailsExpanded",
  "orderHeader": "Profile-module__DeDpKa__orderHeader",
  "orderHeaderCollapsed": "Profile-module__DeDpKa__orderHeaderCollapsed",
  "orderHistory": "Profile-module__DeDpKa__orderHistory",
  "orderStatus": "Profile-module__DeDpKa__orderStatus",
  "orders": "Profile-module__DeDpKa__orders",
  "ordersChartItem": "Profile-module__DeDpKa__ordersChartItem",
  "ordersContainer": "Profile-module__DeDpKa__ordersContainer",
  "pending": "Profile-module__DeDpKa__pending",
  "pending_confirmation": "Profile-module__DeDpKa__pending_confirmation",
  "pending_reward": "Profile-module__DeDpKa__pending_reward",
  "processing": "Profile-module__DeDpKa__processing",
  "profileInfo": "Profile-module__DeDpKa__profileInfo",
  "referralCardMobile": "Profile-module__DeDpKa__referralCardMobile",
  "referralCardMobileItem": "Profile-module__DeDpKa__referralCardMobileItem",
  "referralCardMobileLabel": "Profile-module__DeDpKa__referralCardMobileLabel",
  "referralCardMobileRow": "Profile-module__DeDpKa__referralCardMobileRow",
  "referralCardMobileValue": "Profile-module__DeDpKa__referralCardMobileValue",
  "referralCode": "Profile-module__DeDpKa__referralCode",
  "referralCodeRow": "Profile-module__DeDpKa__referralCodeRow",
  "referralHelp": "Profile-module__DeDpKa__referralHelp",
  "referralSection": "Profile-module__DeDpKa__referralSection",
  "referralSectionDivider": "Profile-module__DeDpKa__referralSectionDivider",
  "referralStatus": "Profile-module__DeDpKa__referralStatus",
  "referralsChartItem": "Profile-module__DeDpKa__referralsChartItem",
  "referralsReferItem": "Profile-module__DeDpKa__referralsReferItem",
  "referralsTable": "Profile-module__DeDpKa__referralsTable",
  "referralsTableContainer": "Profile-module__DeDpKa__referralsTableContainer",
  "referralsTopRow": "Profile-module__DeDpKa__referralsTopRow",
  "referredUsersSection": "Profile-module__DeDpKa__referredUsersSection",
  "reward_processed": "Profile-module__DeDpKa__reward_processed",
  "sectionHeader": "Profile-module__DeDpKa__sectionHeader",
  "sectionIcon": "Profile-module__DeDpKa__sectionIcon",
  "showOnDesktop": "Profile-module__DeDpKa__showOnDesktop",
  "showOnMobile": "Profile-module__DeDpKa__showOnMobile",
  "spinner": "Profile-module__DeDpKa__spinner",
  "successful": "Profile-module__DeDpKa__successful",
  "tabButton": "Profile-module__DeDpKa__tabButton",
  "tabItemsGrid": "Profile-module__DeDpKa__tabItemsGrid",
  "tabNavigation": "Profile-module__DeDpKa__tabNavigation",
  "tokenCardItem": "Profile-module__DeDpKa__tokenCardItem",
  "tokenCardLabel": "Profile-module__DeDpKa__tokenCardLabel",
  "tokenCardRow": "Profile-module__DeDpKa__tokenCardRow",
  "tokenCardValue": "Profile-module__DeDpKa__tokenCardValue",
  "tokenDisplaySection": "Profile-module__DeDpKa__tokenDisplaySection",
  "tokenListContainer": "Profile-module__DeDpKa__tokenListContainer",
  "transactionLink": "Profile-module__DeDpKa__transactionLink",
  "userInfo": "Profile-module__DeDpKa__userInfo",
  "verificationStatus": "Profile-module__DeDpKa__verificationStatus",
  "verified": "Profile-module__DeDpKa__verified",
});
